import { workspaceServiceClient } from 'services/backofficeIntegration/http/client/createWorkspaceServiceClient';
import { mutationEndpoint } from 'services/backofficeIntegration/http/endpointDefinition';
import { type DeleteV1WorkspacesByWorkspaceIdResponses } from 'services/generated/workspace-service';

type SuccessDto = DeleteV1WorkspacesByWorkspaceIdResponses['200'];

type DeleteWorkspaceOptions = {
  workspaceId: string;
};

export const httpDeleteWorkspace = mutationEndpoint({
  callEndpoint: ({ workspaceId }: DeleteWorkspaceOptions) => {
    return workspaceServiceClient
      .delete<SuccessDto>(`/v1/workspaces/${workspaceId}`)
      .then(res => res.data);
  },
});
